import { defineMessages } from 'react-intl';

export default defineMessages({
  title: {
    id: 'classesStudents.editClass.title',
    defaultMessage: 'ADD / EDIT GROUP',
  },
  editTitle: {
    id: 'classesStudents.editClass.editTitle',
    defaultMessage: 'EDIT GROUP',
  },
  addTitle: {
    id: 'classesStudents.editClass.addTitle',
    defaultMessage: 'ADD GROUP',
  },
  viewTitle: {
    id: 'classesStudents.editClass.viewTitle',
    defaultMessage: 'VIEW GROUP',
  },
  loadList: {
    id: 'classesStudents.editClass.loadList',
    defaultMessage: 'Load list',
  },
  color: {
    id: 'classesStudents.editClass.color',
    defaultMessage: 'Color',
  },
  picture: {
    id: 'classesStudents.editClass.picture',
    defaultMessage: 'Picture',
  },
  classData: {
    id: 'classesStudents.editClass.classData',
    defaultMessage: 'Class Data',
  },
  students: {
    id: 'classesStudents.editClass.students',
    defaultMessage: 'Students',
  },
  addStudent: {
    id: 'classesStudents.editClass.addStudent',
    defaultMessage: 'Add student',
  },
  studentRemoved: {
    id: 'classesStudents.editClass.studentRemoved',
    defaultMessage: 'Student removed',
  },
  undo: {
    id: 'classesStudents.editClass.undo',
    defaultMessage: 'Undo',
  },
  edit: {
    id: 'classesStudents.editClass.edit',
    defaultMessage: 'Edit',
  },
  delete: {
    id: 'classesStudents.editClass.delete',
    defaultMessage: 'Delete',
  },
  cancel: {
    id: 'classesStudents.editClass.cancel',
    defaultMessage: 'Cancel',
  },
  back: {
    id: 'classesStudents.editClass.back',
    defaultMessage: 'Back',
  },
  save: {
    id: 'classesStudents.editClass.save',
    defaultMessage: 'Save',
  },
  school: {
    id: 'classesStudents.editClass.school',
    defaultMessage: 'School',
  },
  level: {
    id: 'classesStudents.editClass.level',
    defaultMessage: 'Level',
  },
  year: {
    id: 'classesStudents.editClass.year',
    defaultMessage: 'Year',
  },
  name: {
    id: 'classesStudents.editClass.name',
    defaultMessage: 'Name',
  },
  period: {
    id: 'classesStudents.editClass.period',
    defaultMessage: 'Period',
  },
  view: {
    id: 'classesStudents.editClass.view',
    defaultMessage: 'View',
  },
  errorDeleteStudent: {
    id: 'classesStudents.editClass.errorDeleteStudent',
    defaultMessage: 'Couldnt delete this student, due the already have an evaluations answered',
  },
});
